export default {
  display: "grid",
  gridGap: "0.5rem",
  py: 2,
  px: 0
};
